import React from 'react';
import { ModalBody } from 'reactstrap';
import { FileType, FileTypeResult, getFileType } from '../../../utilities/getFileType';
import { ICipDocumentsResources } from '../cip-documents.props.autogenerated';

interface ICipDocumentsCardProps {
    documents: any;
    resources: ICipDocumentsResources;
    CLASS_NAME: string;
    setModalContent: React.Dispatch<React.SetStateAction<JSX.Element | null>>;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    showFilters: boolean;
}

const CipDocumentsCard: React.FC<ICipDocumentsCardProps> = ({
    documents,
    resources,
    CLASS_NAME,
    setModalContent,
    setIsModalOpen,
    showFilters
}) => {
    const handlePreview = (altText?: string, uri?: string, mediaTypeValue?: number) => {
        const { type }: FileTypeResult = getFileType(altText, uri, mediaTypeValue);
        let content: JSX.Element | null;

        switch (type) {
            case FileType.Pdf:
                content = (
                    <ModalBody>
                        <h3>{altText || resources.cipDocumentsDocumentOpenPreview}</h3>
                        <iframe
                            className={`${CLASS_NAME}__preview-frame`}
                            src={`${uri}#toolbar=0`}
                            title={resources.cipDocumentsDocumentOpenPreview}
                        />
                    </ModalBody>
                );
                break;
            case FileType.Image:
                content = (
                    <ModalBody>
                        <h3>{altText || resources.cipDocumentsDocumentOpenPreview}</h3>
                        <img src={uri} className={`${CLASS_NAME}__preview-frame`} alt={altText} />
                    </ModalBody>
                );
                break;
            case FileType.Video:
                content = (
                    <ModalBody>
                        <h3>{altText || resources.cipDocumentsDocumentOpenPreview}</h3>
                        <video src={uri} controls className={`${CLASS_NAME}__preview-frame`} />
                    </ModalBody>
                );
                break;
            default:
                content = (
                    <ModalBody>
                        <h3>{altText || resources.cipDocumentsDocumentOpenPreview}</h3>
                        <p>{resources.cipDocumentsDocumentFailureMessage}</p>
                        <a href={uri} target='_blank' rel='noopener noreferrer'>
                            {resources.cipDocumentsDocumentDownload}
                        </a>
                    </ModalBody>
                );
        }

        setModalContent(content);
        setIsModalOpen(true);
    };
    return (
        <>
            {documents.length === 0 ? (
                <div>{resources.cipDocumentsNoDocumentsFound}</div>
            ) : (
                <ul className={`${CLASS_NAME}__document-list`}>
                    {documents.map((mediaLocation: any, idx: any) => {
                        const { Uri: uri, AltText: altText, MediaPurpose, MediaTypeValue } = mediaLocation;
                        const { type } = getFileType(altText, uri, MediaTypeValue);

                        return (
                            <li key={uri || idx} className={`${CLASS_NAME}__document-list-item`}>
                                <div className={`${CLASS_NAME}__document-list-item__title`}>
                                    {altText || resources.cipDocumentsDocumentNoTitle}
                                </div>
                                {uri && (
                                    <div className={`${CLASS_NAME}__document-list-actions`}>
                                        <a href={uri} target='_blank' rel='noopener noreferrer'>
                                            {resources.cipDocumentsOpenDocument}
                                        </a>
                                        {type !== FileType.Unknown && (
                                            <button
                                                className='msc-cta__primary'
                                                type='button'
                                                onClick={() => handlePreview(altText, uri, MediaTypeValue)}
                                            >
                                                {resources.cipDocumentsDocumentOpenPreview}
                                            </button>
                                        )}
                                    </div>
                                )}
                                {showFilters && (
                                    <div className={`${CLASS_NAME}__document-list-description`}>
                                        {resources.cipDocumentsDocumentPurposeLabel} {MediaPurpose || resources.cipDocumentsFilterNoKey}
                                        {MediaTypeValue && <span> | {getFileType(altText, uri, MediaTypeValue).type}</span>}
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default CipDocumentsCard;
